import { render } from "./Menu.vue?vue&type=template&id=1cdb3658"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=1cdb3658&lang=scss"
script.render = render

export default script